import { cn } from "@bem-react/classname"
import { selectCatalog, ITheme, getStat, splitdot, getCatalog, insertAfter, insertBefore, maxnumlen} from "modules/Catalog"
import { IjQ } from "pages/TeacherTest/TeacherTest"
import { FC, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import "./Theme.scss"
import { useDrag, useDrop } from 'react-dnd'
import {WithMath} from "utils/withMath"

declare global {
    interface Window {
      jQuery: IjQ
    }
  }



const Theme: FC<{theme: ITheme, haveTheory: boolean, numLen?: number, ipath: number[], inner?: boolean}> = ({theme, haveTheory, numLen, ipath, inner}) => {
    const cnTheme = cn('Theme')
    
    const state = useSelector(selectCatalog)
    const stats = getStat(state, theme)
    let href = theme.href
    const cnCounter = cn('Counter Counter')
    let counter_class = cnCounter()
    let good = undefined
    if (href){
        switch (state.activeStat) {
            case '':
                href += '&filter=all'
                break
            case 'seen':
                href += '&filter=not_seen'
                good = stats ? (stats.right + stats.wrong) / stats.total : undefined
                break
            case 'right':
                href += '&filter=right'
                good = stats ? stats.right/ (stats.right + stats.wrong) : undefined
                break
            case 'wrong':
                href += '&filter=wrong'
                good = stats ? stats.right/ (stats.right + stats.wrong) : undefined
                break
            case 'clones':
                href += '&filter=all_a'
                break
            case 'seen_clones':
                href += '&filter=not_seen_a'
                good = stats ? (stats.right_a! + stats.wrong_a!) / stats.total_a! : undefined
                break
            case 'right_clones':
                href += '&filter=right_a'
                good = stats ? stats.right_a!/ (stats.right_a! + stats.wrong_a!) : undefined
                break
            case 'wrong_clones':
                href += '&filter=wrong_a'
                good = stats ? stats.right_a!/ (stats.right_a! + stats.wrong_a!) : undefined
                break
        }
    }
    if (good !== undefined){
        if (good >= 0.8 ){
            counter_class = cnCounter('green')
        } else if (good >= 0.5){
            counter_class = cnCounter('yellow')
        } else {
            counter_class = cnCounter('red')
        }
        
    }
    const theoryClick = () => {
        window.jQuery.get(
            '/rus_sprav?ajax=1&id=' + theme.theory!, 
            function(resp:string){
                window.jQuery('<div></div>').html(resp).dialog({
                    title:'',
                    width:Math.min(window.jQuery(window).width()-20, 820),
                    maxHeight:window.jQuery(window).height() * 0.8})
                },
            'html'
        );
        return false
    }
    const title = splitdot(theme.title)
    if (theme.noSplit || !numLen){
        title.num = undefined
        title.name = theme.title
    }
    let titlehtml
    if (numLen && title.num && !inner){
        titlehtml = <><span className={cnTheme('titlenum', {bold: !haveTheory && state.activeType === 'sgia'})} style={{width: numLen+'px'}}>{title.num}</span><span className={!haveTheory && state.activeType === 'sgia' ? 'titleWithoutTheory': ''}><WithMath>{title.name}</WithMath></span></>
        if (!haveTheory && state.activeType === 'sgia') {
            counter_class = cnCounter('bold')
        }
    } else if (numLen && title.num){
        titlehtml = <><span className={cnTheme('titlenum')} style={{width: numLen+'px'}}>{title.num}</span><WithMath>{title.name}</WithMath></>
    } else {
        titlehtml = <WithMath>{title.name}</WithMath>
    }
    const titlecn = haveTheory ? cnTheme('title'):cnTheme('titlenot')
    let onclick = (event: React.MouseEvent<HTMLDivElement>) => {event.stopPropagation(); }
    const [open, setOpen] = useState(theme.isOpen === undefined? true : theme.isOpen)
    const style = {cursor: 'auto'}
    if (theme.children && theme.children.length){
        onclick = (event: React.MouseEvent<HTMLDivElement>) => {event.stopPropagation(); setOpen(!open); }
        style.cursor = 'pointer'
    }
    const titlestyle = {fontWeight: 'normal'}
    if (theme.isBold) {
        titlestyle.fontWeight = 'bold'
    }

    const query = new URLSearchParams(window.location.search);
    let sorting = false
    if (query.get('sort')){
        const catalog = getCatalog(state)
        if (catalog?.sortable){
            sorting = true
        }
    }
    const ppath = [...ipath]
    const item_id = ppath.pop()
    const [{isDragging}, dragRef] = useDrag(() => ({
        type: 'theme' + ppath.join(' '),
        item: {id: item_id, type: 'theme' + ppath.join(' ')},
        collect: monitor => ({
          isDragging: !!monitor.isDragging(),
        }),
      }), [item_id])
    const dispatch = useDispatch()
    const [{ isOverAfter }, dropAfterRef] = useDrop(() => ({
        accept: 'theme' + ppath.join(' '),
        drop: (item:{id:number}, monitor) => {
            dispatch(insertAfter({id:item.id, ipath, type:state.activeType, catalog:state.activeCatalog}))
        },
        collect: (monitor) => ({
            isOverAfter: !!monitor.isOver()
          })
      }), [item_id, 'a'])
      const [{ isOverBefore }, dropBeforeRef] = useDrop(() => ({
        accept: 'theme' + ppath.join(' '),
        drop: (item:{id:number}, monitor) => {
            dispatch(insertBefore({id:item.id, ipath, type:state.activeType, catalog:state.activeCatalog}))
        },
        collect: (monitor) => ({
            isOverBefore: !!monitor.isOver()
          })
      }), [item_id, 'b'])

      const cnumLen = theme.children?maxnumlen(theme.children):0
      const showEmpty = state.showEmpty
      if (!sorting){
        if (!showEmpty && theme.count === 0){
            return <></>
        }
        return <div className={cnTheme() + ((theme.children && theme.children.length)?' nobg':'')} onClick={onclick} style={style}>
            {haveTheory?<>{theme.theory ? <span className={cnTheme('theory')} onClick={theoryClick}>Т</span>: <span className={cnTheme('theoryph')}></span>}</>:''}
            {theme.children && theme.children.length ?  <span className={titlecn} style={titlestyle}>{titlehtml}</span>: <a className={titlecn} href={theme.href + '&filter=all'}>{titlehtml}</a>}
            {state.activeStat === '' || stats === undefined ? <span className={counter_class}>{theme.count}</span> :''}
            {state.activeStat === 'seen' && stats !== undefined ? <span className={counter_class}>{stats.total - stats.right - stats.wrong} из {stats.total}</span> :''}
            {state.activeStat === 'right' && stats !== undefined? <span className={counter_class}>{stats.right} из {stats.right + stats.wrong}</span> :''}
            {state.activeStat === 'wrong' && stats !== undefined? <span className={counter_class}>{stats.wrong} из {stats.right + stats.wrong}</span> :''}
            {state.activeStat === 'clones' && stats !== undefined? <span className={counter_class}>{stats.total_a}</span> :''}
            {state.activeStat === 'seen_clones' && stats !== undefined? <span className={counter_class}>{stats.total_a! - stats.right_a! - stats.wrong_a!} из {stats.total_a}</span> :''}
            {state.activeStat === 'right_clones' && stats !== undefined? <span className={counter_class}>{stats.right_a} из {stats.right_a! + stats.wrong_a!}</span> :''}
            {state.activeStat === 'wrong_clones' && stats !== undefined? <span className={counter_class}>{stats.wrong_a} из {stats.right_a! + stats.wrong_a!}</span> :''}
            
            {theme.href ? <a className={cnTheme('link')} href={href}>Перейти</a> : ''}
            
            {theme.children && theme.children.length && open? (<div className={cnTheme('children')}> 
                {theme.children.map((el, i)=> <Theme ipath={[...ipath, i]} numLen={cnumLen} key={i} theme={el} haveTheory={false} inner={true}/>)} 
            </div>):''}
        </div>
    }


    const dropAStyle={margin: 0, height:isOverAfter?"30px":"2px", background:isOverAfter?"#ddd":"transparent"}
    const dropBStyle={margin: 0, height:isOverBefore?"30px":"2px", background:isOverBefore?"#ddd":"transparent"}
    
    return <>
    <div ref={dropBeforeRef} style={dropBStyle}></div>
    <div  ref={dragRef} className={cnTheme() + ((theme.children && theme.children.length)?' nobg':'')} onClick={onclick} style={style}>
    {isDragging?'':''}
    {theme.children && theme.children.length ?  <span className={titlecn} style={titlestyle}>{titlehtml}</span>: <a className={titlecn} href={theme.href + '&filter=all'}>{titlehtml}</a>}
    {theme.href ? <a className={cnTheme('link')} href={href}>Перейти</a> : ''}
    
    {theme.children && theme.children.length && open? (<div className={cnTheme('children')}> 
        {theme.children.map((el, i)=> <Theme ipath={[...ipath, i]} key={i} theme={el} haveTheory={false}/>)} 
    </div>):''}
    </div>
    <div ref={dropAfterRef} style={dropAStyle}></div>
    </>
}


export default Theme